import React, {lazy, useContext, useEffect, useRef, useState} from 'react';
import './Faq.css';
import { LocaleContext, ScrollContext } from '../common/App';
import { FaqQuestion, Footer } from './WebsiteCommon';
import { DropdownInfo, LinkSmart } from '../common/Common';
import { Link, useSearchParams } from 'react-router-dom';
import { useIndexUpdate } from '../common/hooks';
import { sanitizeStr } from '../common/util';

const ImprintDe = lazy(() => import('./de/ImprintDe'));

export function Faq(props) {
    const locale = useContext(LocaleContext);

    const [searchParams, setSearchParams] = useSearchParams();

    useIndexUpdate(props.indexUpdate, locale);


    // RENDER:

    // Get the value of the query parameter you're interested in  
    const questionsNoToOpen = searchParams.getAll("question");

    const lowestQuestionNo = Number(questionsNoToOpen[0]);

    return (
        <div className="faq head_img">
            <div className="bottom_padding_high">
                <img className="img_width" src="/customer/images/faq_1.jpg" alt={locale.msgs.FAQ_IMG_1_ALT_TEXT}></img>

                <div className="text_box">
                    <h1 className="text_big_big head_after_img">{locale.msgs.FAQ}</h1>

                    <FaqHead text={locale.msgs.FAQ_HEAD_1} />

                    <div className="faq_question_box">

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_1} open={questionsNoToOpen.includes("1")} noScrollOnOpen={true} answer={locale.msgs.FAQ_ANSWER_1} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_2} open={questionsNoToOpen.includes("2")} noScrollOnOpen={2 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_2} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_3} open={questionsNoToOpen.includes("3")} noScrollOnOpen={3 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_3} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_4} open={questionsNoToOpen.includes("4")} noScrollOnOpen={4 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_4} />

                    </div>


                    <FaqHead text={locale.msgs.FAQ_HEAD_2} />

                    <div className="faq_question_box">

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_5} open={questionsNoToOpen.includes("5")} noScrollOnOpen={true} rawAnswer={
                                <div className="faq_answer" onClick={(e) => e.stopPropagation()}>
                                    <span dangerouslySetInnerHTML={{__html: locale.msgs.FAQ_ANSWER_5}} />
                                    <LinkSmart className="text_2 link_2" to={"/about_us/"} target="_blank">{locale.msgs.WEBSITE}</LinkSmart>
                                    <span className="text_pink">.</span>
                                </div>
                        } />

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_6} open={questionsNoToOpen.includes("6")} noScrollOnOpen={6 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_6} />

                    </div>


                    <FaqHead text={locale.msgs.FAQ_HEAD_3} />

                    <div className="faq_question_box">

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_7} open={questionsNoToOpen.includes("7")} noScrollOnOpen={true} answer={locale.msgs.FAQ_ANSWER_7} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_8} open={questionsNoToOpen.includes("8")} noScrollOnOpen={8 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_8} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_9} open={questionsNoToOpen.includes("9")} noScrollOnOpen={9 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_9} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_10} open={questionsNoToOpen.includes("10")} noScrollOnOpen={10 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_10} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_11} open={questionsNoToOpen.includes("11")} noScrollOnOpen={11 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_11} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_12} open={questionsNoToOpen.includes("12")} noScrollOnOpen={12 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_12} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_13} open={questionsNoToOpen.includes("13")} noScrollOnOpen={13 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_13} />

                    </div>


                    <FaqHead text={locale.msgs.FAQ_HEAD_4} scroll={lowestQuestionNo === 14} />

                    <div className="faq_question_box">

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_14} open={questionsNoToOpen.includes("14")} noScrollOnOpen={true} answer={locale.msgs.FAQ_ANSWER_14} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_15} open={questionsNoToOpen.includes("15")} noScrollOnOpen={15 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_15} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_16} open={questionsNoToOpen.includes("16")} noScrollOnOpen={16 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_16} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_17} open={questionsNoToOpen.includes("17")} noScrollOnOpen={17 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_17} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_18} open={questionsNoToOpen.includes("18")} noScrollOnOpen={18 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_18} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_19} open={questionsNoToOpen.includes("19")} noScrollOnOpen={19 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_19} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_20} open={questionsNoToOpen.includes("20")} noScrollOnOpen={20 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_20} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_21} open={questionsNoToOpen.includes("21")} noScrollOnOpen={21 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_21} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_21_2} open={questionsNoToOpen.includes("21")} noScrollOnOpen={21 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_21_2} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_22} open={questionsNoToOpen.includes("22")} noScrollOnOpen={22 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_22} />

                    </div>


                    <FaqHead text={locale.msgs.FAQ_HEAD_5} />

                    <div className="faq_question_box">
                        
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_23} open={questionsNoToOpen.includes("23")} noScrollOnOpen={true} answer={locale.msgs.FAQ_ANSWER_23} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_24} open={questionsNoToOpen.includes("24")} noScrollOnOpen={24 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_24} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_25} open={questionsNoToOpen.includes("25")} noScrollOnOpen={25 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_25} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_26} open={questionsNoToOpen.includes("26")} noScrollOnOpen={26 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_26} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_27} open={questionsNoToOpen.includes("27")} noScrollOnOpen={27 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_27} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_28} open={questionsNoToOpen.includes("28")} noScrollOnOpen={28 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_28} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_29} open={questionsNoToOpen.includes("29")} noScrollOnOpen={29 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_29} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_30} open={questionsNoToOpen.includes("30")} noScrollOnOpen={30 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_30} />

                    </div>


                    <FaqHead text={locale.msgs.FAQ_HEAD_6} />

                    <div className="faq_question_box">

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_31} open={questionsNoToOpen.includes("31")} noScrollOnOpen={true} rawAnswer={
                                <div className="faq_answer" onClick={(e) => e.stopPropagation()}>
                                    <span dangerouslySetInnerHTML={{__html: locale.msgs.FAQ_ANSWER_31}} />
                                    <LinkSmart className="text_2 link_2" to={"/families/"} target="_blank">{locale.msgs.TO_MEDIATION_PROCESS}</LinkSmart>
                                    <br/>
                                    <span dangerouslySetInnerHTML={{__html: locale.msgs.FAQ_ANSWER_31_2}} />
                                    <LinkSmart className="text_2 link_2" to={"/m_n/"} target="_blank">{locale.msgs.TO_MEDIATION_PROCESS}</LinkSmart>
                                </div>
                        } />

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_32} open={questionsNoToOpen.includes("32")} noScrollOnOpen={32 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_32} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_33} open={questionsNoToOpen.includes("33")} noScrollOnOpen={33 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_33} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_34} open={questionsNoToOpen.includes("34")} noScrollOnOpen={34 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_34} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_35} open={questionsNoToOpen.includes("35")} noScrollOnOpen={35 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_35} />

                    </div>


                    <FaqHead text={locale.msgs.FAQ_HEAD_7} scroll={lowestQuestionNo === 36} />

                    <div className="faq_question_box">

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_36} open={questionsNoToOpen.includes("36")} noScrollOnOpen={true} answer={locale.msgs.FAQ_ANSWER_36} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_37} open={questionsNoToOpen.includes("37")} noScrollOnOpen={37 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_37} />

                    </div>


                    <FaqHead text={locale.msgs.FAQ_HEAD_8} scroll={lowestQuestionNo === 38} />

                    <div className="faq_question_box">

                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_38} open={questionsNoToOpen.includes("38")} noScrollOnOpen={true} answer={locale.msgs.FAQ_ANSWER_38} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_39} open={questionsNoToOpen.includes("39")} noScrollOnOpen={39 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_39} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_40} open={questionsNoToOpen.includes("40")} noScrollOnOpen={40 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_40} />
                        <FaqQuestion question={locale.msgs.FAQ_QUESTION_41} open={questionsNoToOpen.includes("41")} noScrollOnOpen={41 > lowestQuestionNo} answer={locale.msgs.FAQ_ANSWER_41} />

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

const FaqHead = ({text, scroll}) => {
    const scrollContext = useContext(ScrollContext);

    const ref = useRef();
    const [scrollCounter, setScrollCounter] = useState(0);

    useEffect(() => {
        if(scroll) {
            setScrollCounter(1);
        }
    }, [scroll]);

    useEffect(() => {
        if(scrollCounter === 1) {
            setScrollCounter(2);

            // scrollTo() does only scroll if the elements are not visible, so we first want to scroll to the top
            scrollContext.scrollToPlain(0, 0);
        }
        else if(scrollCounter === 2) {
            setScrollCounter(3);

            const rect = ref.current.getBoundingClientRect();
            scrollContext.scrollTo(rect.top, rect.bottom, true, true);
        }
    }, [scrollCounter]);

    return (
        <div ref={ref} className="text_big_big margin_top_mid_high">{text}</div>
    );
}
